import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    padding: [-20, 0],
    paddingTop: 20,
    [theme.breakpoints.up('mobile')]: {
      padding: [-20, -20],
    },
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    height: '100%',
  },
  loader: {
    [theme.breakpoints.up('mobile')]: {
      margin: [20, 20],
    },
    margin: [20, 0],
    width: '100%',
    height: '100%',
  },
  subscriptionInfo: {
    margin: [20, 0],
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      margin: [20, 20],
      width: 330,
    },
  },
  connections: {
    margin: [20, 0],
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      margin: [20, 20],
      width: 330,
    },
  },
  upcomingInvoice: {
    margin: [20, 0],
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      margin: [20, 20],
      width: 320,
    },
  },
  budget: {
    margin: [20, 0],
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      margin: [20, 20],
      width: 280,
    },
  },
  paymentMethod: {
    margin: [20, 0],
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      margin: [20, 20],
      width: 300,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/useStyles.js